import * as React from 'react'

import Stack from '@mui/material/Stack'
import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'

import { I18n, useTranslation } from 'components/hooks/use-translation'
import CourseCard from 'components/atomic/molecules/course-card'
import PathCard from 'components/atomic/molecules/path-card'
import Button from 'components/atomic/atoms/button'
import Text from 'components/atomic/atoms/text'

import { PathOverview, TrackOverview } from 'types/types'

export type CollectionItem = {
    type: 'path' | 'course'
    item: PathOverview | TrackOverview
}

interface PathCollectionsProps {
    title?: string
    endButton?: React.ReactNode
    limit?: number
    showMore?: boolean
    items: CollectionItem[]
}

export default React.memo(({ title, items, limit = 6, showMore = true }: PathCollectionsProps) => {
    const [allVisible, setAllVisible] = React.useState(false)
    const { t }: I18n = useTranslation()

    return (
        <Stack gap="1rem" key={title}>
            <Text variant="h5">{title}</Text>
            <Grid spacing={'1rem'} container>
                {items.slice(0, allVisible ? items.length : limit).map(({ type, item }) => (
                    <Grid item xs={12} sm md={6} lg={4} key={item._id}>
                        {type === 'path' ? (
                            <PathCard {...(item as PathOverview)} />
                        ) : (
                            <CourseCard {...(item as TrackOverview)} />
                        )}
                    </Grid>
                ))}
            </Grid>

            {showMore && items.length > limit ? (
                <Box display="flex" justifyContent="center" width="100%">
                    <Button onClick={() => setAllVisible(!allVisible)}>
                        {allVisible ? t('catalog:buttons.showLess') : t('catalog:buttons.showAll')}
                    </Button>
                </Box>
            ) : null}
        </Stack>
    )
})
